<template>
  <div>
    <div class="content">
      <div class="contentLeft">
        <div class="cont">
          <Rili @clickDate="dateClick" :list="list" />
        </div>
        <div class="text">注:数字下方蓝点表示当日有面试</div>
      </div>
      <div class="contentRit">
        <div class="headBox">
          <div class="name">
            <div class="txt">面试列表：{{ timeTxt }}</div>
            <div class="lsTxt dis-cent" @click="lsClick">历史面试</div>
          </div>
          <div class="cont">
            <!-- <a-dropdown>
              <div class="box">
                <div class="text">全部状态</div>
                <div class="iconfont icon-enter"></div>
              </div>
              <a-menu
                slot="overlay"
                @click="hyClick"
                :selectedKeys=""
              >
                <a-menu-item
                  :key="item.id"
                  v-for="item in typeList"
                  >{{ item.c_name }}</a-menu-item
                >
              </a-menu>
            </a-dropdown> -->
          </div>
        </div>
        <div class="contBox">
          <Kong v-if="list.length == 0" />
          <div class="zCont" v-for="item in list">
            <div class="shijian">
              <div class="name">{{ item.day }}，{{ item.week }}</div>
              <div
                class="text"
                v-if="item.censoring == 3 || item.censoring == -1"
              >
                面试{{ item.censoring == 3 ? "已同意" : "已拒绝" }}
              </div>
              <div
                class="text"
                v-if="item.censoring == 1 || item.censoring == 2"
              >
                {{ item.pd == 1 ? "面试未同意" : "面试已超时" }}
              </div>
            </div>
            <div class="cont" @click="msClick(item.id)">
              <div class="time">{{ item.time }}</div>
              <div class="peoBox">
                <div class="img">
                  <img :src="$imgUrl + item.member.avatars" alt="" srcset="" />
                </div>
                <div class="box">
                  <div class="name">{{ item.member.member_info.realname }}</div>
                  <div class="text c-1">{{ item.remark }}</div>
                </div>
              </div>
              <div class="mobileBox">
                <div class="txt">{{ item.member.mobile }}</div>
                <div
                  class="iconfont icon-fuzhi_o fuzhi_o"
                  @click.stop="fzClick(item)"
                ></div>
              </div>
              <div class="gwBox" v-if="item.job_id">
                面试岗位：{{ item.jobs_name }}
              </div>
              <div class="gwBox" v-if="item.odd_id">
                零工职位：{{ item.odds_name }}
              </div>
              <div
                class="ztBox"
                @click.stop
                v-if="item.censoring == 2 && item.pd == 1"
              >
                <div class="text red" @click.stop>
                  <a-popconfirm
                    title="是否确定拒绝"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="jjConfirm(item)"
                  >
                    拒绝
                  </a-popconfirm>
                </div>
                <div class="text" @click.stop>
                  <a-popconfirm
                    title="是否确定同意"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="tyConfirm(item)"
                  >
                    同意
                  </a-popconfirm>
                </div>
              </div>
            </div>
          </div>
          <div class="fenye" v-if="totalCount > 7">
            <a-pagination
              :default-current="page.pageNo"
              v-model="page.pageNo"
              :total="totalCount"
              :page-size="7"
              @change="pageOnChange"
            />
          </div>
        </div>
      </div>
    </div>
    <MsCont v-if="msShow" :id="msId" @show="msShow = false" />
  </div>
</template>

<script>
import Kong from "../../component/kong.vue";
import MsCont from "../../component/msCont.vue";
import Rili from "./rili.vue";
import { Popconfirm, Modal } from "ant-design-vue";

export default {
  components: {
    MsCont,
    Rili,
    Kong,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
  },
  name: "",
  data() {
    return {
      msId: 0,
      msShow: false,
      msId: "",
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 7,
      },
      list: [],
      totalCount: 0,
      timeTxt: "",
    };
  },
  created() {
    this.page.month = this.$moment().format("YYYY-MM");
    this.listGet();
  },
  methods: {
    searchClick() {
      this.page.jobs_name = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.list = [];
      this.listGet();
      this.totalCountGet();
    },
    jjConfirm(item) {
      this.$post("/nozzle/web/interview_refuse", {
        id: item.id,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("已拒绝该面试申请");
          this.listGet();
        }
      });
    },
    tyConfirm(item) {
      this.$post("/nozzle/web/interview_agree", {
        id: item.id,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("已同意该面试申请");
          this.listGet();
        }
      });
    },
    dateClick(data) {
      console.log(data);
      if (data.type == 1) {
        this.timeTxt = data.time1;
        this.page.month = data.time;
        this.page.day = "";
      }
      if (data.type == 2) {
        this.timeTxt = this.$moment(data.time).format("YYYY年MM月DD日");
        this.page.month = "";
        this.page.day = data.time;
      }
      this.totalCount = 0;
      this.page.pageNo = 1;
      this.listGet();
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/interview_gets", this.page).then((res) => {
        console.log(res.data);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.week = this.$moment(e.start_time).format("dddd");
            e.day = this.$moment(e.start_time).format("MM月DD日");
            e.time = this.$moment(e.start_time).format("HH:mm");
            e.pd = this.timeDb(e.start_time);
            // if (e.censoring == 1 || e.censoring == -1) {
            //   e.member.member_info.mobile = this.phoJm(
            //     e.member.member_info.mobile
            //   );
            // }
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    fzClick(e) {
      if (e.censoring == 1 || e.censoring == -1) {
        this.$message.error("已拒绝或者对方未同意不能复制！");
        return;
      }
      const textarea = document.createElement("textarea");
      textarea.value = e.mobile;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
    phoJm(phone) {
      phone = "" + phone;
      var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式
      var phone = phone.replace(reg, "$1****$2");
      return phone;
    },
    timeDb(time2) {
      // 创建两个时间对象
      const time1 = this.$moment();
      time2 = this.$moment(time2);
      // 比较时间
      let pd = 0;
      if (time1.isBefore(time2)) {
        pd = 1;
      } else if (time1.isAfter(time2)) {
        pd = 2;
      } else {
        pd = 3;
      }
      return pd;
    },
    lsClick(){
      // this.$router.push({
      //   path: "/gongsi/msList",
      //   query: {},
      // });
      window.open("#/gongsi/msList");
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.totalCount = 0;
      this.listGet();
    },
    msClick(id) {
      this.msShow = true;
      this.msId = id;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  margin: auto;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  height: calc(100vh - 85px);
  width: 1280px;
  .contentLeft {
    width: 350px;
    border-right: 1px solid #ebebeb;
    .cont {
      height: 300px;
    }
    .text {
      color: #9c9c9c;
      padding: 10px 15px;
    }
  }
  .contentRit {
    width: calc(100% - 350px);
    box-sizing: border-box;
    .headBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 70px;
      padding: 0 20px;
      .name {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        .txt {
          font-weight: 600;
          font-size: 20px;
        }
        .lsTxt{
          font-size: 14px;
          background-color: #1596ff;
          color: #Fff;
          width: 75px;
          height: 35px;
          border-radius: 5px;
          cursor: pointer;
        }
      }
      .cont {
        display: flex;
        align-items: center;
        .box {
          margin-left: 20px;
          border-radius: 5px;
          background-color: #eef4fc;
          height: 35px;
          width: 150px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .text {
            width: calc(100% - 20px);
            padding-left: 12px;
            box-sizing: border-box;
          }
          .iconfont {
            font-size: 12px;
          }
        }
      }
    }
    .contBox {
      height: calc(100% - 70px);
      overflow: auto;
      box-sizing: border-box;
      padding: 0 20px 20px;
      .zCont {
        margin-bottom: 20px;
        .shijian {
          margin-bottom: 10px;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .text {
            margin-right: 10px;
            font-size: 14px;
            color: #e95a07;
          }
        }
      }
      .cont {
        cursor: pointer;
        border-radius: 10px;
        border: 1px solid #ebebeb;
        height: 90px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        .time {
          width: 70px;
          font-size: 18px;
          color: #666;
        }
        .peoBox {
          height: 45px;
          width: 230px;
          display: flex;
          .img {
            width: 45px;
            border-radius: 50%;
            height: 45px;
          }
          .box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 10px;
            width: calc(100% - 45px);
            box-sizing: border-box;
            .text {
              font-size: 12px;
              color: #9c9c9c;
            }
          }
        }
        .mobileBox {
          display: flex;
          align-items: center;
          width: 200px;
          .fuzhi_o {
            font-size: 20px;
            position: relative;
            top: 1px;
            margin-left: 5px;
            color: #299fff;
            cursor: pointer;
          }
        }
        .gwBox {
          width: calc(100% - 600px);
        }
        .ztBox {
          width: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          .text {
            color: #1596ff;
            margin-left: 15px;
          }
        }
      }
    }
  }
}
</style>
